// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"ChangePhoneNumber_buttonWrapper__MKg1b","input":"ChangePhoneNumber_input__v0VRS","options":"ChangePhoneNumber_options__cjDBv","name":"ChangePhoneNumber_name__2JjNW"};